import React, { useEffect, useRef, useState } from "react";
import * as Icon from "@desenvolvimento-intuix/ui-icons";

import { ICheckbox } from "../../../interfaces/checkbox";
import { IStatus } from "../../../interfaces/status";

import { useName } from "../../../hooks/useName";
import { useInformations } from "../../../hooks/useInformations";

import { Informations } from "../../Informations";

import * as S from "./styles";
import { Label } from "../../Label";

export const Checkbox: React.FC<ICheckbox> = (props) => {
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    setChecked(!!props.checked);
  }, [props.checked]);

  const onChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    if (props.disabled) return;

    const { name } = event.currentTarget;

    const nextState = !checked;

    if (props.checked === undefined) setChecked(nextState);

    props.onChange && props.onChange(name, nextState, event);
  };

  const [status, setStatus] = useState<IStatus>("VALIDATED");

  useEffect(() => {
    if (props.required && !checked) {
      setStatus("ERROR_REQUIRED");
      return;
    }

    setStatus("VALIDATED");
  }, [props.required, checked]);

  const informationsRef = useRef(null);

  const { informations, onValidate, getInformationsClasses } = useInformations({
    ref: informationsRef,
    inputProps: props,
  });

  const { name } = useName(props.name);

  const [id, setId] = useState("");

  useEffect(() => {
    setId(`checkbox-${name}`);
  }, [name]);

  return (
    <S.Container className="input-checkbox-container">
      <S.Wrapper className="input-checkbox-wrapper">
        <S.Checkbox
          {...{
            checked,
            className: `input-checkbox ${getInformationsClasses()} ${
              props.disabled ? "disabled" : ""
            }`,
          }}
        >
          {checked && <Icon.Check />}

          <input
            {...{
              ...(props as any),
              id,
              checked,
              name,
              type: "checkbox",
              onChange,
              "data-input": "checkbox",
              "data-status": status,
              "data-checked": checked,
              onBlur: onValidate,
              required: props.required,
              disabled: props.disabled,
            }}
            style={{ opacity: 0 }}
          />
        </S.Checkbox>
        {props.label && (
          <Label className="input-checkbox-label" htmlFor={id}>
            {props.label}
          </Label>
        )}
      </S.Wrapper>
      <Informations {...{ name, ref: informationsRef, ...informations }} />
    </S.Container>
  );
};
